module.exports = __webpack_public_path__ + "static/media/cross.3f423f2c.svg";